import { LogLevel, PublicClientApplication, type Configuration } from "@azure/msal-browser";

/**
 * MSAL Configuration for ContentQA Module
 * Separate instance for ContentQA's own client ID
 */
const contentqaMsalConfig: Configuration = {
  auth: {
    authority: import.meta.env.VITE_TENANT_ID as string,
    clientId: import.meta.env.VITE_CONTENTQA_CLIENT_ID as string,
    redirectUri: import.meta.env.VITE_CONTENTQA_REDIRECT_URI as string,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const contentqaMsalInstance = new PublicClientApplication(contentqaMsalConfig);